<template lang="pug">
  .video-container(:style="{ backgroundImage: 'url(' + video.img + ')' }")
    youtube.youtube(v-if="startPlay" :video-id="video.id" @ready="ready" :player-width="'100%'" :player-height="'100%'" :player-vars="{ autoplay: 0, rel: 0, modestbranding: 1 }")
    transition(name="play")
      .play-mask(v-if="!startPlay" @click="play")
        .play-btn
          img(src="~@/assets/images/play.svg")
</template>

<script>

export default {
  name: 'YoutubePlayer',
  props: ['video'],
  data () {
    return {
      startPlay: false
    }
  },
  computed: {

  },
  methods: {
    play() {
      this.startPlay = true;
    },
    ready (event) {
      this.player = event.target;
      this.player.playVideo();
    },
  },
  mounted() {


  }

}
</script>

<style lang="sass" scoped>
  .video-container
    width: 100%
    margin-top: 50px
    background-size: cover
    background-position: 50% 50%
    &:first-child
      margin: 0
    &::before
      content: ""
      display: block
      width: 100%
      padding-top: 56.25%
    .youtube
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      background-color: #000
    .play-mask
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      background-color: rgba(#000,0.3)
      cursor: pointer
      transition: background-color 0.2s
      .play-btn
        width: 100px
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%,-50%)
        transition: transform 0.2s
        img
          width: 100%
      &:hover
        background-color: rgba(#000,0.2)
        .play-btn
          transform: translate(-50%,-50%) scale(1.05)

  .play-enter-active, .play-leave-active
    transition-property: opacity
    transition-duration: .5s
  .play-enter, .play-leave-active
    opacity: 0
</style>



// WEBPACK FOOTER //
// src/components/YoutubePlayer.vue